import { httpGet } from '@inner-source/cis-shared/transports';

const getLeaderboard = async ({ typeId }) => httpGet('/get-leaderboard', { typeId });

export default getLeaderboard;
